// Copyright (c) Microgreen Manager LLC. All rights reserved. Proprietary and confidential. Unauthorized copying is strictly prohibited.
import { sendToServer } from '@seedplanner/shared-utils';
import * as React from 'react';
import { Box, MenuItem } from '../../lib/base';
import { PictureAsPdfIcon } from '../../lib/icons';
import * as routes from '../../routes';
import LoadingWarningDialog from '../common/dailog/LoadingWarningDialog';

export default function LoadingMenuItem() {
  const [isOpen, setIsOpen] = React.useState(false);
  const onClose = () => {
    setIsOpen(false);
  };
  return (
    <Box key="loading-menu-item-box">
      <MenuItem
        key="loading-menu-item"
        onClick={() => {
          sendToServer({
            route: routes.ERROR,
            body: JSON.stringify({
              errorMessage: 'User clicked on export PDF button but JSPDF is not available in task options',
              location: window?.location?.toString() ?? 'window.location is undefined',
            }),
            title: 'no_jspdf_on_click',
          });
          setIsOpen(true);
        }}
      >
        <PictureAsPdfIcon />
        Export to PDF
      </MenuItem>
      <LoadingWarningDialog isOpen={isOpen} onClose={onClose} />
    </Box>
  );
}
